// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Afirst/Afirst.css */

.everything{
    background-color: white;
    overflow-y: auto;
}

.main-first{
    position: relative;
    padding: 0;
    margin: 0;
    height: 9vh;
}

.main-second{
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 0;
    margin: 0;
    height: 69vh;
}

.main-second.main-second--full{
    height: 91vh;
}

/* 
.second-sidebar{
    width: 25%;
    padding: 0;
    margin: 0;
    border-right:0.5px solid;
    border-color: rgb(212, 212, 212);

} */

.second-form{
    width: 100%;
    padding: 0;
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Afirst/Afirst.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,WAAW;IACX,UAAU;IACV,SAAS;AACb","sourcesContent":["/* src/components/routes/Afirst/Afirst.css */\n\n.everything{\n    background-color: white;\n    overflow-y: auto;\n}\n\n.main-first{\n    position: relative;\n    padding: 0;\n    margin: 0;\n    height: 9vh;\n}\n\n.main-second{\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    padding: 0;\n    margin: 0;\n    height: 69vh;\n}\n\n.main-second.main-second--full{\n    height: 91vh;\n}\n\n/* \n.second-sidebar{\n    width: 25%;\n    padding: 0;\n    margin: 0;\n    border-right:0.5px solid;\n    border-color: rgb(212, 212, 212);\n\n} */\n\n.second-form{\n    width: 100%;\n    padding: 0;\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
